import { render, staticRenderFns } from "./AppSupheader.vue?vue&type=template&id=563393a5&scoped=true"
import script from "./AppSupheader.vue?vue&type=script&lang=ts"
export * from "./AppSupheader.vue?vue&type=script&lang=ts"
import style0 from "./AppSupheader.vue?vue&type=style&index=0&id=563393a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563393a5",
  null
  
)

/* custom blocks */
import block0 from "./AppSupheader.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports